// FAQ content from Patient MM V3 - used as fallback when API returns empty
export const FAQ_STATIC_CONTENT = [
  {
    id: 1,
    title: "Can I use mindmitra without an internet connection?",
    description: "Mindmitra require an internet connection to be used for the audio, and/or video-based counselling/ therapy sessions since it's a web application.",
  },
  {
    id: 2,
    title: "Is my information kept private on Mindmitra?",
    description: "Mindmitra will not misuse your personal information and any confidential information shared by you. We use Google services for the session and the video/audio session are safe like any other Google product/services.",
  },
  {
    id: 3,
    title: "Can I use Mindmitra to diagnose mental health problems?",
    description: "The mindmitra and its contents are designed to diagnose or treat mental health problems through counselling/Therapy administered by experts of the respective areas. It's a substitute for online professional mental health care.",
  },
  {
    id: 4,
    title: "How to access services of Mindmitra by persons under the age of eighteen (18)?",
    description: "If you are a minor, you shall not register as a patient of the Mindmitra by yourself. You can access this website under the guidance of a parent or legal guardian (Register as parent/guardian on behalf of minor).",
  },
  {
    id: 5,
    title: "How will I get my diagnosis report after the consultation?",
    description: "You can access your consultation report under the completed session from Mindmitra's website logging in using your credentials.",
  },
  {
    id: 6,
    title: "Can I cancel my appointment?",
    description: "Yes. You can cancel your appointment in case of some unavoidable reasons. But you have to cancel the session from the website at least 48 hours prior to the session time and there will be a cancellation charge of 50%. Hence 50% of your booking amount will be refunded.",
  },
  {
    id: 7,
    title: "Will I get any refund if the online session was unsuccessful due to network issues from expert's end or if the expert couldn't turn up?",
    description: "The patient shall get a full refund within 5 working days in case of above scenario, once Mindmitra team completes an investigation of the incident. Please note that the refund will be subjected to terms and conditions. A refund claim can be rejected in case Mindmitra team find out there was no lapses from expert's end.",
  },
];
